import React, { createContext, useContext, useEffect, useState } from 'react';
import { api } from './api';

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
  // null = checking, false = logged out, object = user
  const [user, setUser] = useState(null);

  useEffect(() => {
    const token = localStorage.getItem('adm_token');
    if (!token) {
      setUser(false);
      return;
    }
    api
      .get('/api/auth/me')
      .then((r) => setUser(r.data))
      .catch(() => {
        localStorage.removeItem('adm_token');
        setUser(false);
      });
  }, []);

  const login = async (email, password) => {
    const { data } = await api.post('/api/auth/login', { email, password });
    localStorage.setItem('adm_token', data.access_token);
    localStorage.setItem('adm_user', JSON.stringify(data.user));
    setUser(data.user);
    return data.user;
  };

  const logout = () => {
    localStorage.removeItem('adm_token');
    localStorage.removeItem('adm_user');
    setUser(false);
  };

  return <AuthCtx.Provider value={{ user, login, logout }}>{children}</AuthCtx.Provider>;
}

export function useAuth() {
  return useContext(AuthCtx);
}
